import { defineComponent as _defineComponent } from 'vue'
import { useContext, computed, toRefs, useRouter } from '@nuxtjs/composition-api';

export interface Props {
    theme?: 'light' | 'dark',
    variant?: 'square' | 'long',
    monochrome?: boolean,
    type?: 'outline' | 'transparent',
    size?: 's' | 'm' | 'l' | 'xl',
    href?: string,
    loading?: 'lazy' | 'eager',
    disabled?: boolean,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AffilityLogo',
  props: {
    theme: null,
    variant: { default: 'square' },
    monochrome: { type: Boolean, default: false },
    type: null,
    size: { default: 'm' },
    href: { default: '/' },
    loading: { default: 'eager' },
    disabled: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { theme?: 'light' | 'dark', variant: 'square' | 'long', monochrome: boolean, type?: 'outline' | 'transparent', size: 's' | 'm' | 'l' | 'xl', href: string, loading: 'lazy' | 'eager', disabled: boolean };



const {
    theme,
    variant,
    monochrome,
    type,
    href,
    size,
    loading,
} = toRefs(props);

const nuxt = useContext();
const currentColorMode = nuxt.$colorMode;
const $t = nuxt.i18n.t;
const router = useRouter();

const ariaLabel = computed(() => {
    const route = router.resolve(href.value);
    const routeBaseName = route.resolved.name;
    return routeBaseName === 'home' ? $t('home') : routeBaseName;
});

const getLogo = computed(() => {
    const logoTheme = theme.value || currentColorMode.value || 'light';
    const logoVariant = variant.value || 'square';
    const logoColor = monochrome.value ? 'monochrome' : 'colored';
    const logoType = type.value || '';

    const fileNameParts = [logoVariant, logoTheme, logoColor];
    if (logoType) {
        fileNameParts.push(logoType);
    }
    return require(`~/assets/affility/images/logo/${fileNameParts.join('-')}.svg`);
})

return { __sfc: true,props, theme, variant, monochrome, type, href, size, loading, nuxt, currentColorMode, $t, router, ariaLabel, getLogo }
}

})